import * as basicLightbox from "basiclightbox";
import { MpBookmark } from "../../common/bookmark.js";
import {
	MultiFreeGLightbox,
	MultiGLightbox,
} from "../../common/image_gallery.js";
import { mbSocialSharing, socialSharing } from "../../common/sharing.js";
import {
	formAddCsrfProtection,
	initAjaxLightbox,
	loadScript,
	updateGAdataLayer,
} from "../../common/utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// NEXT PREV NAVIGATION ARTICOLE
	for (const el of document.querySelectorAll(".article_nav--desktop")) {
		el.addEventListener("mouseenter", (event) => {
			const target = event.currentTarget;
			target.querySelector(".article_nav__title").classList.add("d-flex");
			target.querySelector("span").style.opacity = 1;
		});
		el.addEventListener("mouseleave", (event) => {
			const target = event.currentTarget;
			target.querySelector("span").style.opacity = 0;
			target.querySelector(".article_nav__title").classList.remove("d-flex");
		});
	}

	// PROGRESS ARTICLE
	let latestKnownScrollY = 0;
	let ticking = false;
	function requestTick() {
		if (!ticking) {
			requestAnimationFrame(articleProgress);
			ticking = true;
		}
	}
	function articleProgress() {
		// allow further rAFs to be called
		ticking = false;
		const currentScrollY = latestKnownScrollY;
		const article_rect = document
			.querySelector(".article__content")
			.getBoundingClientRect();
		const article_top = article_rect.top + currentScrollY;
		const article_height = Number.parseFloat(
			getComputedStyle(
				document.querySelector(".article__content"),
				null,
			).height.replace("px", ""),
		);
		const scrollPercent =
			(100 * (currentScrollY - article_top)) /
			(article_height - window.innerHeight);
		const progress = document.querySelector(".progress-reading");
		progress.style.width = `${scrollPercent}%`;
		if (
			!(window.getComputedStyle(progress).display === "none") &&
			(scrollPercent < 0 || scrollPercent > 100)
		) {
			progress.style.display = "none";
		} else if (
			window.getComputedStyle(progress).display === "none" &&
			scrollPercent >= 0 &&
			scrollPercent <= 100
		) {
			progress.style.display = "block";
		}
	}
	function onScroll() {
		latestKnownScrollY = window.scrollY;
		requestTick();
	}
	window.addEventListener("scroll", onScroll, false);
	// END PROGRESS ARTICLE

	// Lightbox tag galleria associata a gioco/tag nei paragrafi
	for (const el of document.querySelectorAll("._article_gallery")) {
		const images = [];
		if (el.dataset.elementsGallery === "1") {
			for (const img of el.querySelectorAll(".gallery__img")) {
				images.push({ href: img.dataset.gallerySrc });
			}
		}
		new MultiGLightbox({
			url: el.dataset.mainGalleryUrl,
			per_page: 20,
			selector: el.dataset.gallerySelector,
			elements: images,
		});
	}

	// Lightbox tag galleria "libera" nei paragrafi
	for (const el of document.querySelectorAll("._article_free_gallery")) {
		new MultiFreeGLightbox({
			selector: el.dataset.gallerySelector,
		});
	}

	// Lightbox per le immagini singole
	for (const el of document.querySelectorAll(".galleria_single img")) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			const article_gallery = new MultiFreeGLightbox({
				elements: [{ href: el.dataset.gallerySrc, title: el.dataset.caption }],
			});
			article_gallery.instance.open();
		});
	}

	if (document.querySelector("#social-share")) {
		// SOCIAL SHARE
		const x_text = document.querySelector("#social-share .X").dataset.text;
		const fb = new socialSharing(
			document.querySelector("#social-share .facebook"),
			{ kind: "facebook" },
		);
		const x = new socialSharing(document.querySelector("#social-share .X"), {
			kind: "x",
			title: x_text,
			suffix: " via @Multiplayerit",
		});
		const tg = new socialSharing(
			document.querySelector("#social-share .telegram"),
			{ kind: "telegram" },
		);
		const wa = new socialSharing(
			document.querySelector("#social-share .whatsapp"),
			{ kind: "whatsapp" },
		);
	}
	const mb_share = document.querySelector("#_share-mb");
	if (mb_share) {
		mb_share.addEventListener("click", (event) => {
			event.preventDefault();
			mbSocialSharing(mb_share);
		});
	}

	// COMMENT COUNT
	const comments_count = document.querySelector("#_comments_number");
	if (
		!!comments_count &&
		comments_count.dataset.ct &&
		comments_count.dataset.id
	) {
		fetch(
			`/misc/comments_counter/${comments_count.dataset.ct}/${comments_count.dataset.id}/`,
			{
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			},
		)
			.then((response) => response.json())
			.then((data) => {
				if (Number.parseInt(data.comment_count) > 149) {
					comments_count.textContent = "HOT";
				} else {
					comments_count.textContent = data.comment_count;
				}
			})
			.catch((error) => {
				console.warn(error);
			});
	}

	// BOOKMARK CORRELATO
	const gamecardContainer = document.querySelector("#_gamecard_container");
	const bookmarks_container = document.querySelector("#_gamecard_bookmarks");
	if (gamecardContainer) {
		if (gamecardContainer.dataset.ct && gamecardContainer.dataset.id) {
			fetch(
				`/misc/bookmarks_and_vote/${gamecardContainer.dataset.ct}/${gamecardContainer.dataset.id}/`,
				{
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
					cache: "no-cache",
				},
			)
				.then((response) => response.json())
				.then((data) => {
					const gamecard_bookmarks = data.gamecard_bookmarks;
					if (gamecard_bookmarks && bookmarks_container) {
						bookmarks_container.innerHTML = gamecard_bookmarks;
						init_gamecard_bookmarks();
					}
				})
				.catch((error) => {
					console.warn(error);
				});
		}
	}

	// VOTO RECENSIONE e LEGGI DOPO
	const article_container = document.querySelector("#_article_container");
	if (article_container.dataset.ct && article_container.dataset.id) {
		fetch(
			`/misc/bookmarks_and_vote/${article_container.dataset.ct}/${article_container.dataset.id}/`,
			{
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
				cache: "no-cache",
			},
		)
			.then((response) => response.json())
			.then((data) => {
				if (
					document.querySelector("#_rating_form") &&
					data.gamecard_rating_form
				) {
					document.querySelector("#_rating_form").innerHTML =
						data.gamecard_rating_form;
					import("../../common/rating.js").then(({ initRating }) => {
						initRating();
					});
				}
				if (document.querySelector("#_article_read_later")) {
					document.querySelector("#_article_read_later").innerHTML =
						data.follow_bookmark_form;
				}
				init_article_bookmark();
				initAjaxLightbox(
					document.querySelectorAll("#_readers_votes"),
					"modal-users",
				);
			})
			.catch((error) => {
				console.warn(error);
			});
	}

	// Rece prank su "Two Point Campus"
	if (article_container.dataset.id === "275937") {
		const review_vote = document.querySelector(
			"#reviewvote .article__verdict__boxes__vote",
		);
		if (review_vote) {
			const observer = new IntersectionObserver((entries, observer) => {
				entries.map((entry) => {
					if (entry.isIntersecting) {
						review_vote.innerHTML = `
          <style>
          .article__verdict__boxes__vote > div > strong.special-vote span {
            display: block;
            font-size: 1rem;
          }
          .swirl-in-fwd {
            -webkit-animation: swirl-in-fwd 0.5s ease-out .5s both;
                    animation: swirl-in-fwd 0.5s ease-out .5s both;
          }
          @-webkit-keyframes swirl-in-fwd {
            0% {
              -webkit-transform: rotate(-540deg) scale(0);
                      transform: rotate(-540deg) scale(0);
              opacity: 0;
            }
            100% {
              -webkit-transform: rotate(0) scale(1);
                      transform: rotate(0) scale(1);
              opacity: 1;
            }
          }
          @keyframes swirl-in-fwd {
            0% {
              -webkit-transform: rotate(-540deg) scale(0);
                      transform: rotate(-540deg) scale(0);
              opacity: 0;
            }
            100% {
              -webkit-transform: rotate(0) scale(1);
                      transform: rotate(0) scale(1);
              opacity: 1;
            }
          }
          </style>
          <div class='swirl-in-fwd'>
            <strong class='special-vote'>
              110<span>e lode</span>
            </strong>
          </div>`;
						observer.unobserve(entry.target);
					}
				});
			});
			observer.observe(review_vote);
		}
	}

	// report form
	const reportLightbox = init_report_window();
	if (
		!!document.querySelector("#login_registration_container") &&
		!!document.querySelector("#user_nav #_user_panel_container") === false
	) {
		window.globalLoginWindowHandler.errorReportLogin(
			document.querySelectorAll("#_error_report"),
		);
	}

	document.querySelector("#_error_report").addEventListener("click", (e) => {
		e.preventDefault();
		e.stopImmediatePropagation();
		reportLightbox.show();
		return false;
	});

	// collapsible table
	for (const table of document.querySelectorAll(
		"#_article_container .article__content table",
	)) {
		const rows = table.querySelectorAll("tr").length;
		let max_rows;
		if (document.body.classList.contains("_article-mb")) {
			max_rows = 4;
		} else {
			max_rows = 11;
		}
		const hide_index = max_rows - 1;
		if (rows > max_rows) {
			const rows = table.querySelectorAll("tr");
			for (let index = 0; index < rows.length; index++) {
				const tr = rows[index];
				if (index > hide_index) {
					tr.classList.add("d-none");
				} else if (index === hide_index) {
					const expand = document.createElement("div");
					expand.innerHTML = "Guarda la tabella completa &blacktriangledown;";
					expand.classList.add(
						"article--table--expander",
						"btn",
						"btn-block",
						"btn-outline-primary",
						"py-3",
						"font-weight-bold",
					);
					expand.addEventListener("click", (event) => {
						event.preventDefault();
						for (const el of [...tr.parentElement.children]) {
							el.classList.remove("d-none");
						}
						event.target.classList.add("d-none");
					});
					let column_count = 0;
					const table_rows = table.rows;
					if (table_rows.length > 0) {
						const cells = table_rows[0].cells;
						for (let i = 0, len = cells.length; i < len; ++i) {
							column_count += cells[i].colSpan;
						}
					}
					const expand_tr = document.createElement("tr");
					const expand_td = document.createElement("td");
					expand_td.setAttribute("colSpan", column_count);
					expand_td.classList.add("p-0");
					expand_td.appendChild(expand);
					expand_tr.appendChild(expand_td);
					table.querySelector("tbody").appendChild(expand_tr);
				}
			}
		}
	}

	// article index
	const article_index = document.querySelector("#_article_index");
	if (article_index) {
		for (const el of document.querySelectorAll("._index_toggle")) {
			el.addEventListener("click", (event) => {
				event.preventDefault();
				article_index.classList.toggle("closed");
				const label = el.querySelector("#_index_label");
				if (label) {
					if (label.textContent === "Mostra di più") {
						label.textContent = "Mostra di meno";
					} else {
						label.textContent = "Mostra di più";
					}
				}
			});
		}
	}

	// Social embeds
	document.addEventListener("lazybeforeunveil", (event) => {
		const target = event.target;
		if (target.classList.contains("_tw_embed")) {
			// Twitter embeds
			// biome-ignore lint/complexity/useArrowFunction: twitter code
			window.twttr = (function (d, s, id) {
				const fjs = d.getElementsByTagName(s)[0];
				const t = window.twttr || {};
				if (d.getElementById(id)) return t;
				const js = d.createElement(s);
				js.id = id;
				js.src = "https://platform.twitter.com/widgets.js";
				fjs.parentNode.insertBefore(js, fjs);
				t._e = [];
				// biome-ignore lint/complexity/useArrowFunction: twitter code
				t.ready = function (f) {
					t._e.push(f);
				};
				return t;
			})(document, "script", "twitter-wjs");

			twttr.ready((twttr) => {
				const tweetError = target.querySelector("._tw_error");
				const tw = target.querySelector('div[id^="tw_"]');
				twttr.widgets
					.createTweet(target.dataset.id, tw)
					.then((data) => {
						if (typeof data === "undefined") {
							tweetError.classList.remove("d-none");
							tweetError.classList.add("d-flex");
						}
					})
					.catch((error) => {
						tweetError.classList.remove("d-none");
						tweetError.classList.add("d-flex");
					});
			});
		} else if (target.classList.contains("_ig_embed")) {
			loadScript(
				"instagram-js",
				"https://www.instagram.com/static/bundles/metro/EmbedSDK.js/33cd2c5d5d59.js",
			)
				.then(() => {
					const ig = target.querySelector('div[id^="ig_"]');
					ig.innerHTML = JSON.parse(
						ig.querySelector("script").textContent,
					).embed;
					instgrm.Embeds.process();
				})
				.catch((error) => {
					console.warn(" --- Error: ", error);
				});
		} else if (target.classList.contains("_bl_embed")) {
			loadScript("bluesky-js", "https://embed.bsky.app/static/embed.js")
				.then(() => {
					const bl = target.querySelector('div[id^="bl_"]');
					bl.innerHTML = JSON.parse(
						bl.querySelector("script").textContent,
					).embed;
					window.bluesky.scan(bl);
				})
				.catch((error) => {
					console.warn(" --- Error: ", error);
				});
		}
	});

	// YouTube embeds lazy load
	for (const embed of document.querySelectorAll("._yt_embed")) {
		const observer = new IntersectionObserver((entries, observer) => {
			entries.map((entry) => {
				if (entry.isIntersecting) {
					const yt = entry.target.dataset.yt;
					entry.target.src = `https://www.youtube.com/embed/${yt}`;
					observer.unobserve(entry.target);
				}
			});
		});
		observer.observe(embed);
	}
});

// Error report
function init_report_window() {
	const reportForm = document.querySelector(".error_report_form");
	if (reportForm) {
		reportForm
			.querySelector("input[type='button']")
			.addEventListener("click", (event) => {
				event.preventDefault();
				event.stopImmediatePropagation();
				formAddCsrfProtection(reportForm).then((data) => {
					const formData = new FormData(reportForm);
					fetch(reportForm.getAttribute("action"), {
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						method: "POST",
						cache: "no-cache",
						body: formData,
					})
						.then((response) => response.text())
						.then((data) => {
							if (data) {
								document.querySelector("#_error_report").innerHTML = data;
								document
									.querySelector("#_error_report")
									.classList.add("disabled");
							}
							reportLightbox.close();
						})
						.catch((error) => {
							console.warn(" --- Error: ", error);
						});
				});
			});
		const reportLightbox = basicLightbox.create(
			document.querySelector(".error_report_container"),
			{
				onShow: (instance) => {
					// biome-ignore format lint: reason=doesn't get selection text with the arrow function
					const getSelectionText = function () {
						let text = "";
						if (window.getSelection) {
							text = window.getSelection().toString();
						} else if (
							document.selection &&
							document.selection.type !== "Control"
						) {
							text = document.selection.createRange().text;
						}
						return text;
					};
					const errorReportContainer = instance.element();
					const pageSelectionText = getSelectionText();
					const textarea = errorReportContainer.querySelector("textarea");
					if (pageSelectionText !== "") {
						textarea.textContent = `[QUOTE]${pageSelectionText}[/QUOTE] \n\n`;
					}
				},
				onClose: (instance) => {
					instance.element().querySelector("textarea").value = "";
				},
			},
		);
		return reportLightbox;
	}
}

// Bookmarks
function init_gamecard_bookmarks() {
	const game_follow = new MpBookmark(
		document.querySelector("#_gamecard_follow"),
		{
			message: document.querySelector("#_gamecard_follow .tab_label"),
			message_on: "Non seguire",
			message_off: "Segui",
			form: document.querySelector("#_gamecard_follow .bookmarks_form"),
		},
	);
}

function init_article_bookmark() {
	const article_follow = new MpBookmark(
		document.querySelector("#_article_read_later"),
		{
			message: document.querySelector("#_article_read_later .tab_label"),
			message_on: "Articolo salvato",
			message_off: "Leggi dopo",
			form: document.querySelector("#_article_read_later .bookmarks_form"),
			trigger_on: () => {
				document
					.querySelector("#_saved_articles_link")
					.classList.remove("disabled");
				// GA4
				updateGAdataLayer("read_later");
			},
		},
	);
}
